var _module_exports ="<!-- History Context -->\n<div class=\"navCtxt\" gov-history-ctxt></div>\n\n<!-- Full - Committeee -->\n<div committee\n     box-tmpl=\"full\"\n     box-model=\"committee\">\n</div>\n";;
var path = '/app/Main/grcEdit/committee/CommitteeAdd.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;